export default __webpack_public_path__ + "static/media/Lozenge 3.a2b311c7.png";